const xlsx = require("xlsx");
const path = require("path");

const exportExcel = (data, workSheetColumnNames, workSheetName, filePath) => {
  const workBook = xlsx.utils.book_new();
  const workSheetData = [workSheetColumnNames, ...data];
  const workSheet = xlsx.utils.aoa_to_sheet(workSheetData);
  xlsx.utils.book_append_sheet(workBook, workSheet, workSheetName);
  xlsx.writeFile(workBook, path.resolve(filePath));
};

const exportDataToExcel = (
  records,
  workSheetColumnNames,
  workSheetName,
  filePath
) => {
  const data = records.map((rec) => {
    // console.log("RECORDS", [...record]);
    return [
      rec.SN,
      rec.LeaveType,
      rec.EmployeeName,
      rec.DateRequested,
      rec.StartDate,
      rec.EndDate,
      rec.LeaveDays,
      rec.ActedBy,
      rec.ReasonForRejection,
      rec.Status,
    ];
  });
  exportExcel(data, workSheetColumnNames, workSheetName, filePath);
};

module.exports = exportDataToExcel;



// WEBPACK FOOTER //
// ./src/utils/exportToExcel/exportService.js